import { Button, Stack, Text, VStack } from "@chakra-ui/react";
import { ReactNode } from "react";

interface RedButtonProps {
  title: string;
  children: ReactNode;
  onClick: () => void;
  buttonText: string;
  show: boolean;
  loading?: boolean;
}

export const RedButton = ({
  title,
  children,
  onClick,
  buttonText,
  show,
  loading = false,
}: RedButtonProps) =>
  show ? (
    <Stack
      justifyContent={"space-between"}
      w="full"
      direction={["column", "row"]}
      h="full"
      alignItems={"center"}
    >
      <VStack justifyContent={"flex-start"}>
        <Text w="full" fontSize="lg">
          {title}
        </Text>
        {children}
      </VStack>
      <Button
        variant="outline"
        borderColor="kydRed.200"
        color="kydRed.200"
        onClick={onClick}
        disabled={loading}
        isDisabled={loading}
        isLoading={loading}
      >
        {buttonText}
      </Button>
    </Stack>
  ) : null; 